export const base = {
  credentialsKey: 'dev-qb.auth',
  userKey: 'dev-qb.usr',
  recoveryKey: 'dev-qb.hlp',
  version: '2.0.1',
  auth0Domain: 'auth.colbisecurebids.com',
  auth0ClientId: '',
  site: 'ca',
  publicReportsUrl: 'https://qb2-la-prod-test.s3.us-west-1.amazonaws.com/public/PublicReports/',
  auth0CallbackUrl: 'https://testing.qualitybidders.net/auth-callback',
  auth0Audience: 'https://api-testing.qualitybidders.net',
  // A list of domains that will be iterated over when a user logs out. Each page will be opened in a hidden iframe and a localStorage token set, telling the client to log out.
  ssoDomains: ['http://localhost:4202', 'https://testing.colbisecurebids.com'],
  sbUrl: 'https://testing.colbisecurebids.com',
};
